export default {
    "meta": {
        "title": "Can You Run Multiple Trading Bots Simultaneously?",
        "description": "Exploring the possibilities of managing several trading bots at once for a diversified and optimized trading strategy."
    },
    "hero": {
        "notification": "Manage more, worry less: Learn about multiple bot setups",
        "h1": "Can You Run Multiple Trading Bots Simultaneously?",
        "paragraph1": "Trading automation has revolutionized the way we engage with the markets, but what if one bot isn't enough? Can you run multiple bots to manage diverse strategies and assets?",
        "paragraph2": "The short answer is yes, and it can open up a world of possibilities. Running multiple trading bots not only diversifies your portfolio but also helps you spread risk and optimize performance. Let's dive into the potential of multi-bot setups, especially with tools like Gunbot, which is specifically designed for these complex environments.",
        "chartSymbol": "BTC/USD",
        "chartFeatures": [
            { "id": 1, "title": "Real-time Trade Monitoring", "description": "Track multiple trades happening across different bots and strategies." },
            { "id": 2, "title": "Multi-timeframe Analysis", "description": "Leverage multiple bots to analyze different timeframes for better precision." }
        ],
        "reviewHeading": "What Gunbot users say"
    },
    "block1": {
        "heading": "The Power of Multi-Bot Setups",
        "paragraph": "In today's trading environment, running a single bot might not always cut it. By running multiple trading bots, you can execute distinct strategies on different markets or exchanges, allowing you to tailor each bot's behavior to specific market conditions. This approach enhances diversification and reduces exposure to risks associated with any single strategy or asset. For instance, Gunbot makes this possible with ease, enabling traders to duplicate their setup and customize each instance for a unique trading goal.",
        "imgAlt": "Dashboard showing multiple bot instances running simultaneously",
        "featureTitle1": "Run bots on different markets",
        "featureDescription1": "Handle various markets and trading pairs by setting up distinct instances of Gunbot.",
        "featureTitle2": "Diversify strategies",
        "featureDescription2": "Each bot can run its own strategy, from scalping to long-term holding, ensuring your trades are as diverse as your portfolio.",
        "featureTitle3": "Spread your risk",
        "featureDescription3": "By distributing trades across different bots and markets, you avoid over-concentrating risk on a single bot or asset.",
        "featureTitle4": "Optimize for speed",
        "featureDescription4": "Gunbot allows you to run bots on multiple exchanges, helping you increase trading speed and proximity to markets."
    },  
    "quote": {
        "paragraph": "Running multiple instances of Gunbot lets me fine-tune my strategies. I can focus one bot on high-volatility pairs while another trades more conservatively."
    },
    "resources": {
        "heading": "Resources for Expanding Your Trading Setup",
        "subheading": "Useful links for managing multiple bots and optimizing your trading strategies",
        "description": "Check out these resources to learn more about how Gunbot supports multi-bot trading and custom strategies.",
        "resources": [
            {
                "title": "Setting up multiple Gunbot instances",
                "description": "A guide to running multiple instances of Gunbot efficiently.",
                "link": "https://www.gunbot.com/blog/run-gunbot-linux-vps-pm2-guide/",
                "linkText": "Read the guide"
            },
            {
                "title": "Custom strategy examples",
                "description": "Explore custom strategies for different bots.",
                "link": "https://www.gunbot.com/support/docs/custom-strategies/code-examples/",
                "linkText": "View examples"
            },
            {
                "title": "Supported exchanges",
                "description": "Check which exchanges Gunbot can operate on simultaneously.",
                "link": "https://www.gunbot.com/exchanges/",
                "linkText": "See the list"
            },
            {
                "title": "AutoConfig Pair Management",
                "description": "Learn how to use AutoConfig to manage pairs dynamically across multiple bots.",
                "link": "https://www.gunbot.com/support/guides/trading-logic-and-optimization/autoconfig-control-pair-settings/",
                "linkText": "Learn more"
            }
        ]
    },
    "block2": {
        "heading": "Why Choose Gunbot for Multi-Bot Trading?",
        "paragraph": "Gunbot is uniquely designed to handle multiple bot instances efficiently. With its flexible configuration options and powerful AutoConfig tool, you can automate complex trading setups across various markets and strategies. Whether you're targeting high-frequency trades on one exchange or longer-term positions on another, Gunbot makes it easy to run and manage multiple bots simultaneously. Each instance can operate independently, allowing you to maximize your trading potential while minimizing risk.",
        "imgAlt": "Trading chart"
    },
    "cta": {
        "text": "Interested in setting up multiple trading bots? Contact us today to learn more.",
        "linkText": "Get in touch",
        "link": "https://www.gunbot.com/contact/",
        "linkTitle": "Contact Gunbot support"
    },
    "pricing": {
        "heading": "Choose Your Gunbot Plan and Start Trading Multiple Bots",
        "primaryButtonText": "I want this!",
        "yearlyAdmonition": "-50%",
        "lifetimeAdmonition": "Best value",
        "tabs": { 
            "Monthly": [],
            "Annual": [],
            "Lifetime": []
        },
        
        
        "joinGunbotCommunity": "Join Gunbot community",
        "moreDetailsAbout": "More details about"
    }
}
